import {
  SFDC_NEW_RECORD,
  SFDC_UPDATE_RECORD,
  SFDC_FIND_RECORD,
  XERO_UPDATE_INVOICE_RECORD,
  XERO_CREATE_SALES_INVOICE,
  XERO_CREATE_OR_UPDATE_CONTACT,
  XERO_CREATE_OR_UPDATE_ITEMS,
  XERO_CREATE_CREDIT_NOTE,
  XERO_TRIGGER_INVOICE_RECORD,
  XERO_NEW_MODIFY_ITEM,
  XERO_NEW_MODIFY_INVOICE,
  SALES_FORCE_CREATE_NEW_SALES_INVOICE,
  SALES_FORCE_CREATE_NEW_PRODUCT_RECORD,
  XERO_NEW_PAYMENT_RECORD,
  SFDC_CREATE_OR_UPDATE_PAYMENT,
  XERO_CREATE_OR_UPDATE_PURCHASE_ORDER,
  NEW_XERO_CREDIT_NOTE,
  SFDC_CREATE_UPDATE_CREDIT_NOTE,
  XERO_CREATE_QUOTE,
  XERO_UPDATE_QUOTE_RECORD,
  SFDC_UPDATE_QUOTE,
  WC_NEW_PRODUCT,
  SFDC_SYNC_WC_PRODUCT,
  SFDC_TRIGGER_XERO_PDF,
  XERO_CREATE_INVOICE_PDF,
  WC_NEW_CUSTOMER,
  SFDC_SYNC_ACCOUNT,
  WC_NEW_ORDER,
  SFDC_SYNC_OPPORTUNITY,
  XERO_NEW_BANKTRANSACTION,
  SFDC_CREATE_OR_UPDATE_TRANSACTION,
} from "../../steps";
import {
  QUICKBOOKS_CREATE_INVOICE,
  QUICKBOOKS_CREATE_OR_UPDATE_CUSTOMER,
  QUICKBOOKS_CREATE_OR_UPDATE_ITEM,
  QUICKBOOKS_NEW_PAYMENT_RECORD,
  SFDC_SYNC_QUICKBOOK_PAYMENT,
} from "../../moduleSteps/quickbooksSteps";
import {
  SFDC_UPDATE_OPPORTUNITY,
  SFDC_UPDATE_PRODUCT_DETAILS,
} from "../../moduleSteps/salesforceSteps";
import { SFTP_NEW_CONTACT, SFTP_NEW_ITEM } from "../../moduleSteps/sftpSteps";
import { WC_UPDATED_ORDER } from "../../moduleSteps/woocommerceSteps";
import {
  XERO_CREATE_CREDIT_NOTE_ALLOCATION,
  XERO_GET_ITEMS,
  XERO_GET_ONLINE_INVOICE_URL,
  XERO_EMAIL_INVOICE,
  XERO_NEW_CONTACT_RECORD,
  XERO_NEW_ITEM_RECORD,
} from "../../moduleSteps/xeroSteps";

const AppMap = {
  XCRALLOC: XERO_CREATE_CREDIT_NOTE_ALLOCATION,
  EMLINV: XERO_EMAIL_INVOICE,
  RETINV: XERO_GET_ONLINE_INVOICE_URL,
  NREC: SFDC_NEW_RECORD,
  UREC: SFDC_UPDATE_RECORD,
  FREC: SFDC_FIND_RECORD,
  CSIN: XERO_CREATE_SALES_INVOICE,
  CCON: XERO_CREATE_OR_UPDATE_CONTACT,
  CITM: XERO_CREATE_OR_UPDATE_ITEMS,
  CCRNT: XERO_CREATE_CREDIT_NOTE,
  SFCSIN: SALES_FORCE_CREATE_NEW_SALES_INVOICE,
  NSPE: SALES_FORCE_CREATE_NEW_PRODUCT_RECORD,
  SFIPDF: SFDC_TRIGGER_XERO_PDF,
  XIPDF: XERO_CREATE_INVOICE_PDF,
  XIUP: XERO_UPDATE_INVOICE_RECORD,
  XNREC: XERO_TRIGGER_INVOICE_RECORD,
  FITM: XERO_NEW_MODIFY_ITEM,
  XNINV: XERO_NEW_MODIFY_INVOICE,
  XNPR: XERO_NEW_PAYMENT_RECORD,
  SFNPR: SFDC_CREATE_OR_UPDATE_PAYMENT,
  XNPO: XERO_CREATE_OR_UPDATE_PURCHASE_ORDER,
  XNCRN: NEW_XERO_CREDIT_NOTE,
  SFCRN: SFDC_CREATE_UPDATE_CREDIT_NOTE,
  CXQT: XERO_CREATE_QUOTE,
  XQUP: XERO_UPDATE_QUOTE_RECORD,
  USFQ: SFDC_UPDATE_QUOTE,
  XNBT: XERO_NEW_BANKTRANSACTION,
  CSFT: SFDC_CREATE_OR_UPDATE_TRANSACTION,
  SFUPD: SFDC_UPDATE_PRODUCT_DETAILS,
  XIRD: XERO_GET_ITEMS,

  NWCPE: WC_NEW_PRODUCT,
  CNSFP: SFDC_SYNC_WC_PRODUCT,
  NWCCE: WC_NEW_CUSTOMER,
  CNSFC: SFDC_SYNC_ACCOUNT,
  UWCCU: WC_NEW_CUSTOMER,
  USFC: SFDC_SYNC_ACCOUNT,
  NWCOR: WC_NEW_ORDER,
  CSFOP: SFDC_SYNC_OPPORTUNITY,

  UWCOR: WC_UPDATED_ORDER,
  USFOP: SFDC_UPDATE_OPPORTUNITY,

  NXCR: XERO_NEW_CONTACT_RECORD,
  FTPSC: SFTP_NEW_CONTACT,
  NXIR: XERO_NEW_ITEM_RECORD,
  FTPSI: SFTP_NEW_ITEM,

  // Quickbooks MappingsUQINV

  CCUS: QUICKBOOKS_CREATE_OR_UPDATE_CUSTOMER,
  CQITM: QUICKBOOKS_CREATE_OR_UPDATE_ITEM,
  CQINV: QUICKBOOKS_CREATE_INVOICE,
  // payment record steps
  QNPR: QUICKBOOKS_NEW_PAYMENT_RECORD,
  SFSQP: SFDC_SYNC_QUICKBOOK_PAYMENT,

  //UQCUS: UPDATE_Q,
  // UQITM:,
  // UQINV:,
};

export { AppMap };
